import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IApp } from './app.service';
import { ApiService } from '../api.service';

export interface ICategory {
  'id': number;
  'name': string;
  'description': string;
  'apps': IApp[];
}

@Injectable()
export class CategoryService {

  constructor(
    private apiService: ApiService
  ) {
    this.apiService.init();
  }

  getCategories(): Promise<ICategory[]> {
    return this.apiService.client.categories.GET()
      .map((res) => {
        return this.apiService.handleResponse(res).results;
      })
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/category.service.ts